function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3831 15.3137C22.3602 15.3137 20.7263 13.6798 20.7263 11.6569C20.7263 9.63398 22.3602 8 24.3831 8C26.406 8 28.0399 9.6339 28.0399 11.6568C28.0399 13.6797 26.406 15.3137 24.3831 15.3137ZM24.3831 10.3341C23.605 10.3341 22.9826 10.9566 22.9826 11.7346C22.9826 12.5127 23.605 13.1351 24.3831 13.1351C25.1611 13.1351 25.7836 12.5127 25.7836 11.7346C25.7836 10.9566 25.1611 10.3341 24.3831 10.3341Z",
  fill: "#F8B64C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7656 36.7207C28.5275 37.1418 28.1942 37.5277 27.7656 37.8435C27.0037 38.4049 25.9561 38.7207 24.7656 38.7207C23.5751 38.7207 22.5751 38.3698 21.7656 37.8435C21.3371 37.5277 20.9561 37.1418 20.7656 36.7207H28.7656Z",
  fill: "#FF9801"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5903 33.3641H13.1825V22.9383C13.1825 16.7139 18.162 11.7344 24.3864 11.7344C30.6108 11.7344 35.5903 16.7139 35.5903 22.9383V33.3641Z",
  fill: "#FFD15C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4193 32.2754H14.3456C12.4783 32.2754 11 33.7537 11 35.621V36.3213C11 36.7103 11.3112 37.0215 11.7002 37.0215H37.0646C37.4536 37.0215 37.7649 36.7103 37.7649 36.3213V35.621C37.7649 33.8315 36.2088 32.2754 34.4193 32.2754Z",
  fill: "#F8B64C"
});

function SvgNotificationsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/NotificationsActive.3fa0965f.svg";
export { ForwardRef as ReactComponent };